import { Component, OnInit, HostListener, Host } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ConnectRestService } from '../services/connect-rest.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppUtilityService } from '../common/app-utility.service'
import { AppComponent } from '../app.component';
import { EnglishTranslation, MalayTranslation, ProductCode } from '../app.constants';

declare var $: any;

@Component({
  selector: 'app-about-your-business',
  templateUrl: './about-your-business.component.html',
  styleUrls: ['./about-your-business.component.scss']
})
export class AboutYourBusinessComponent implements OnInit {

  isEditMode: boolean = false;
  islamicBanking: boolean = false;
  textContent: any;
  constructor(
    private connect: ConnectRestService,
    private formBuilder: FormBuilder,
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private AppUtility: AppUtilityService,
    public appComp: AppComponent,
  ) {

    this.buildForm();
  }

  // (Begin) Added by CJT / Code by Sonny 09Jul2020
  //change request for SIR 9 and 14 --- start
  // find word 'onPaste="return false" onDrop="return false" onDrag="return false"' for relevant change in HTML
  @HostListener('document:keypress', ['$event'])
  onKeyPress(elemValue) {
    if (elemValue.target.id === "number_of_permanent_employees") {
      return this.AppUtility.numericOnlyValidation(elemValue.key)
    } else if (elemValue.target.id === 'about_your_business') {
      return this.AppUtility.characterValidation(elemValue.key)
    }
  }
  // (End) CJT / Sonny 09Jul2020

  AboutYourBusiness: FormGroup;
  ResponseBody: any;
  RefCCDL: any;
  SSICList: any;
  BNMList: any = [];
  isAboutYourBusiness: boolean = false;
  isSingleSSIC : boolean = false;

  onSubmit() {
    if ($("#obaoform").valid()) {

      this.callSaveRequest();
    }
  }
  // (Begin) CJT 5Jun2020 to call connectRest Service Function
  async restConnect(data, reqID: String) {
    var ServResponse = await this.connect.connectRest(data, reqID, '');
    //   console.log(data);
    return ServResponse;
  }
  async callDropdownValues() {
    this.RefCCDL = JSON.parse(sessionStorage.RefCCDL);
  }
  async callReadRequest() {
    var data = {};
    var ServResponse = await this.restConnect(data, "R0040");
    if (ServResponse.Status == "Success") {
      this.ResponseBody = ServResponse;
      this.setDataResponse(this.ResponseBody);
    }
    else {
   
    }
  }

  async callSaveRequest() {
    var data = {
      KYCQuestionnaires: {
        AboutYourBusiness: this.AboutYourBusiness.value.about_your_business,
        NoofEmployee: parseInt(this.AboutYourBusiness.value.number_of_permanent_employees),
        OBAOHighRiskIndustry: this.AboutYourBusiness.value.yes_or_no_of_above,
        IndustrialSector: this.AboutYourBusiness.value.industry_category,
        PrimarySSICCode: this.AboutYourBusiness.value.PrimarySSICCode,
        BNMSectorialCode: this.AboutYourBusiness.value.BNMCode
      }
    }
    var ServResponse = await this.restConnect(data, "S0040");
    if (ServResponse.Status == "Success") {
      if (!this.isEditMode) {
        this.router.navigate(['/about-your-business-info']);
      } else {
        this.router.navigate(['/director-confirm']);
      }
    }
    else {  
    }
  }

  buildForm() {
    this.AboutYourBusiness = this.formBuilder.group(
      {
        about_your_business: ['', Validators.required],
        number_of_permanent_employees: ['',[ Validators.required, Validators.min(1)]],        
        yes_or_no_of_above: ['', Validators.required],
        industry_category: ['', Validators.required],   
        PrimarySSICCode: ['', Validators.required],
        BNMCode:['']
        // does_your_business_yes_or_no: ['', Validators.required]
      }
    )
  }
  setDataResponse(data) {
      // console.log("about your business" +JSON.parse(data));
    var defaultCountry: String = data.KYCQuestionnaires.MainOperatingCountry;
    if (defaultCountry == "") {
      defaultCountry = "MY";
    }
    var ssicCode = data.KYCQuestionnaires.PrimarySSICCode;
    this.SSICList = data.KYCQuestionnaires.SSICList;
    if ( this.SSICList &&  this.SSICList.length > 0) {
      this.AboutYourBusiness.controls['PrimarySSICCode'].setValidators([Validators.required]);
      this.AboutYourBusiness.get('PrimarySSICCode').updateValueAndValidity();
      this.AboutYourBusiness.controls['about_your_business'].clearValidators();
      this.AboutYourBusiness.get('about_your_business').updateValueAndValidity();   
    } else {
      this.AboutYourBusiness.controls['PrimarySSICCode'].clearValidators();
      this.AboutYourBusiness.get('PrimarySSICCode').updateValueAndValidity();
      this.AboutYourBusiness.controls['about_your_business'].setValidators([Validators.required]);
      this.AboutYourBusiness.get('about_your_business').updateValueAndValidity();
      this.isAboutYourBusiness = true;
    }
    this.AboutYourBusiness.setValue(
      {        
        number_of_permanent_employees: data.KYCQuestionnaires.NoofEmployee,
        about_your_business: data.KYCQuestionnaires.AboutYourBusiness,
        yes_or_no_of_above: data.KYCQuestionnaires.OBAOHighRiskIndustry,
        industry_category: data.KYCQuestionnaires.IndustrialSector,
        PrimarySSICCode: ssicCode,
        BNMCode: ""
        // does_your_business_yes_or_no: data.KYCQuestionnaires.OBAOHighRiskIndustry
      }
    )
    if(data.KYCQuestionnaires.PrimarySSICCode) {
      this.onChangeSSIC(data.KYCQuestionnaires.PrimarySSICCode);
    }    
    if(this.SSICList.length == 1){
      this.isSingleSSIC = true;
      this.AboutYourBusiness.controls['PrimarySSICCode'].patchValue(this.SSICList[0].PrimarySSICCode);
      this.handleBNM(this.SSICList[0].PrimarySSICCode)
    }
    if(data.KYCQuestionnaires.BNMSectorialCode){
      this.AboutYourBusiness.controls['BNMCode'].patchValue(data.KYCQuestionnaires.BNMSectorialCode);
    }    
    this.AboutYourBusiness.updateValueAndValidity();
  }

  onChangeSSIC(e) {
    if(e === 'NOTA') {
      this.AboutYourBusiness.controls['about_your_business'].setValidators([Validators.required]);
      this.AboutYourBusiness.get('about_your_business').updateValueAndValidity();
      this.isAboutYourBusiness = true;
    } else {
      this.AboutYourBusiness.controls['about_your_business'].clearValidators();
      this.AboutYourBusiness.get('about_your_business').updateValueAndValidity();
      this.isAboutYourBusiness = false;
    }
    // this.AboutYourBusiness.controls['about_your_business'].patchValue('');

    this.handleBNM(e)
 
  }

  handleBNM(e){
      //set data for BNM Sectorial Code Dropdown values
       if(!this.isAboutYourBusiness){
        var filteredSSIC = this.SSICList.filter(function(event){
          return event.PrimarySSICCode == e
        });

        this.AboutYourBusiness.controls['BNMCode'].patchValue('');
        if(filteredSSIC[0].HasMultipleBNMCodes){
          this.AboutYourBusiness.controls['BNMCode'].setValidators([Validators.required]);
          this.AboutYourBusiness.get('BNMCode').updateValueAndValidity();
          this.BNMList = filteredSSIC[0].BNMCodeList;
        }else{
          this.BNMList = [];
          this.AboutYourBusiness.controls['BNMCode'].patchValue(filteredSSIC[0].BNMCodeList[0].BNMSectorialCode);
        }
      }
  }

  validateChar(event){
    var value = event.target.value;
    var control = event.target.getAttribute('formcontrolname');
    if(!this.AppUtility.stringValidation(value)){
      this.AboutYourBusiness.get(control).setValue(this.AppUtility.filterInvalidCharacters(value));
    }
  }

  ngOnInit() {
    var langTranslation = sessionStorage.getItem("language");
    this.textContent = langTranslation == 'en-us' || langTranslation == undefined ? EnglishTranslation.AboutYourBusinessScreen : MalayTranslation.AboutYourBusinessScreen;

    this.isEditMode = this.activatedRoute.snapshot.paramMap.get('edit') === 'true' ? true : false;
    this.callDropdownValues();
    this.callReadRequest();
    this.islamicBanking = sessionStorage.getItem('currentProduct') == ProductCode.eBizi ? true : false;
    $(document).ready(function () {
      
      //DCI update (15/7/2020): Disable keypress enter or other to navigate page
      $("form").bind("keypress", function (e) {
        if (e.keyCode == 13) {
          return false;
        }
      })

      $.validator.setDefaults({
        ignore: ".ignore"
      });

      var validator = $("#obaoform").validate({
        rules: {
          number_of_permanent_employees: {
            required: true
          },
          about_your_business: {
            required: false
          },         
          does_your_business_yes_or_no: {
            required: true
          },
          PrimarySSICCode: {
            required: false
          }
        },
        messages: {
          number_of_permanent_employees: {
            required: "Please set number of permanent employees"
          },
          about_your_business: {
            required: "Please enter about your business"
          },
          yes_or_no_of_above: {
            required: "Please select yes or no"
          },
          PrimarySSICCode: {
            required: "Please enter your principle activities in SSM"
          }
        },
        errorPlacement: function (error, element) {

          if (element.attr("name") == "number_of_permanent_employees") {
            error.appendTo($("#number_of_permanent_employees_error_container"));
          }
          if (element.attr("name") == "about_your_business") {
            error.appendTo($("#about_your_business_error_container"));
          }
          if (element.attr("name") == "yes_or_no_of_above") {
            error.appendTo($("#yes_or_no_of_above_error_container"));
          }
          if (element.attr("name") == "business_operates_in") {
            error.appendTo($("#business_operates_in_error_container"));
          }

        },

        submitHandler: function (form) {
          // $("#btn-next").prop("disabled", true);
        }
      });
    });
  }

}
